const Status = {
  registered: "Registered",
  approved: "Approved",
  rejected: "Rejected",
  Online: "Online",
  Offline: "Offline",
  true: "Yes",
  false: "No",
  yes: "Yes",
  no: "No",
  created: "New",
  active: "Active",
  inactive: "In Active",
  confirmed: "Confirmed",
  searching: "Searching",
  schedule: "scheduled",
  started: "Started",
  completed: "Completed",
  cancel: "Cancelled",
  pending: "Pending",
  cancelled: "Cancelled",
  declined: "Declined",

  FindingTrips: "Online",
  PickupInroute: "Pick-up Inroute ",
  DestinationInroute: " Destination Inroute ",
  Completed: "Completed",
  Cancelled: "Cancelled",
  Declined: "Declined",
};
export default Status;
